/**
 * Session Storage 的 key 值
 */
export enum SessionStorageKey {
  USER_BINDING_DATA = 'userBindingData',
  OTP_DATA = 'otpData'
}
